import type { FaireProductEntity } from "../../entity_types/product";

export const p_y6c6r46bes: FaireProductEntity = {
  token: "p_y6c6r46bes",
  type: "product",
  name: "8oz Mason Jar Soy Candles - Rustic  Lid  - 6 Pack No Label",
  brandToken: "b_1uqiazbote",
  brandName: "Heavenly Scents",
  imageUrl:
    "https://cdn.faire.com/fastly/19d864ffd0ffaad9d41e5f7fc7736f33b224e51fc38312ddb822f8de3ec8637f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f2f74232f9eaf2996e0462a78272d096acb1b6728d06a3b0118919685f400000.jpeg",
    "https://cdn.faire.com/fastly/37e7d197105ce45d57b522bba69c1dff58afda9a29b1407ae8c93a64aa0d360c.png",
    "https://cdn.faire.com/fastly/4fd221520a7255a580262925d3e5f7b1edf6e7d559dc94252a8119dd4ccffb13.png",
    "https://cdn.faire.com/fastly/a1e58b0d6964ca99623201c79b724d917838153035809c5b95bb41ebe0de2af9.png",
    "https://cdn.faire.com/fastly/859622a96ae8bcbe0e286c0ab1f7f27b996a89e898066a48127fc98b404a608a.png",
    "https://cdn.faire.com/fastly/a99a96d5ca217647e52d24447b05fd6cd7a64f65bc1e551a5e632575d5979630.png",
  ],
  priceDollars: 5,
  description:
    'This listing is for a 6 pack of 8 oz Mason Jar Soy Candles. These candles come without labels allowing for you to brand them as yours and resell.\n\n𝐎𝐮𝐫 𝐂𝐚𝐧𝐝𝐥𝐞𝐬:\n\n• 100% All Natural Soy Wax\n• 100% Lead Free, Cotton Wick\n• Phthalate Free Fragrances\n• Vegan, Cruelty Free\n• 6 oz net weight of soy wax\n• 35 - 40 Hour Burn Time\n• Threaded Lid\n• Smooth side, 8 oz Mason Jar (Measures 4” H x 2.75” W) - Label area is 2.25" tall\n\n𝐇𝐎𝐖 𝐓𝐎 𝐎𝐑𝐃𝐄𝐑:\n\nSelect the scent you would like from the drop down menu. You will receive 6 of each one.\n\nSee the Image with the fragrances and their descriptions.',
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:45.751Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
